import { render, staticRenderFns } from "./InstallationDetail_Freshdesk.vue?vue&type=template&id=087b160f&"
import script from "./InstallationDetail_Freshdesk.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_Freshdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports